"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = anonymous;

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function anonymous(locals, escapeFn, include, rethrow) {
  escapeFn = escapeFn || function (markup) {
    return markup == undefined ? '' : String(markup).replace(_MATCH_HTML, encode_char);
  };

  var _ENCODE_HTML_RULES = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&#34;",
    "'": "&#39;"
  },
      _MATCH_HTML = /[&<>'"]/g;

  function encode_char(c) {
    return _ENCODE_HTML_RULES[c] || c;
  }

  ;
  ;
  var __output = "";

  function __append(s) {
    if (s !== undefined && s !== null) __output += s;
  }

  ;

  __append("<div class=\"Container\" style=\"max-height: ");

  __append(this.props.visible ? '432px' : '0px');

  __append("; transform: translate3d(0, ");

  __append(this._yTranslate);

  __append("px, 0)\">\n    <div class=\"Keyboard");

  __append(escapeFn(this.props.visible ? ' Keyboard--visible' : ''));

  __append(escapeFn(this.props.inline ? ' Keyboard--inline' : ''));

  __append("\">\n        ");

  var _iterator = _createForOfIteratorHelper(this.keys),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var row = _step.value;
      ;

      __append("\n            <div class=\"Keyboard__row\">\n                ");

      var _iterator2 = _createForOfIteratorHelper(row),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;
          ;

          __append("\n                    <div class=\"Keyboard__key\" keycode=\"");

          __append(escapeFn(key));

          __append("\" onclick=\"this.handleClick('");

          __append(escapeFn(key));

          __append("')\">\n                        <span>");

          __append(escapeFn(key));

          __append("</span>\n                    </div>\n                ");
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      ;

      __append("\n            </div>\n        ");
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  ;

  __append("\n    </div>\n</div>\n");

  return __output;
}